import { Box, Stack, styled as muiStyled } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const AttachmentContainer = muiStyled(Stack)({
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  height: '100%',
  position: 'relative',
  padding: '4rem',
});

export const textStyle = {
  color: abyssColors.primary[300],
  fontWeight: 400,
};

export const iconStyle = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  width: '24px',
  height: '24px',
  padding: '2px',
  background: '#fff',
  color: abyssColors.primary[600],
  border: `1px solid ${abyssColors.primary[600]}`,
  borderRadius: '50%',
  fontSize: '3rem',
  fontWeight: '400',
  cursor: 'pointer',
};


export const PdfContainer = muiStyled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
  gap: '16px',
  marginBottom: '32px',
});

export const PdfItem = muiStyled(Stack)({
  display: 'flex',
  height: '225px',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  border: `1px dashed ${abyssColors.primary[200]}`,
});

export const AttachmentActionContainer = muiStyled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  background: abyssColors.primary[50],
  border: `1px dashed ${abyssColors.primary[200]}`,
  borderRadius: '5px',
  padding: '24px',
  minHeight: '56px',
  boxSizing: 'border-box',
});
